import React from 'react';
import logo from '../../assets/images/logo.png';

// =============================================================================
// Página pública: Eliminación de Datos de Usuario
// Cumple el requisito de Google Play / Google API Services: las apps que
// acceden a datos de usuarios deben ofrecer una forma de solicitar su
// eliminación. Esta página NO requiere autenticación y es enlazable
// directamente desde la consola de Google.
// -----------------------------------------------------------------------------
// IMPORTANTE: actualiza estos datos de contacto con los oficiales de la empresa.
// =============================================================================
const CONTACTO = {
  email: 'privacidad@betelnatural.com',
  empresa: 'Betel Natural',
  // Plazo máximo para procesar la solicitud (días)
  plazoDias: 30
};

const COLOR = '#7B2D8E';

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f5f5f7',
    padding: '40px 16px',
    fontFamily: 'Arial, Helvetica, sans-serif',
    color: '#222',
    lineHeight: 1.6
  },
  card: {
    maxWidth: 760,
    margin: '0 auto',
    background: '#fff',
    borderRadius: 10,
    boxShadow: '0 4px 18px rgba(0,0,0,0.08)',
    overflow: 'hidden'
  },
  header: {
    background: COLOR,
    color: '#fff',
    padding: '28px 32px',
    textAlign: 'center'
  },
  logo: { height: 56, marginBottom: 12, objectFit: 'contain' },
  title: { margin: 0, fontSize: 22, fontWeight: 'bold' },
  body: { padding: '28px 32px' },
  h2: {
    fontSize: 16,
    color: COLOR,
    borderBottom: `2px solid ${COLOR}`,
    paddingBottom: 6,
    marginTop: 26,
    marginBottom: 12
  },
  email: { color: COLOR, fontWeight: 'bold', textDecoration: 'none' },
  footer: {
    padding: '16px 32px',
    borderTop: '1px solid #eee',
    fontSize: 12,
    color: '#888',
    textAlign: 'center'
  }
};

const EliminacionDatos = () => {
  const hoy = new Date().toLocaleDateString('es-GT', {
    year: 'numeric', month: 'long', day: 'numeric'
  });

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <img src={logo} alt={CONTACTO.empresa} style={styles.logo} />
          <h1 style={styles.title}>Eliminación de Datos de Usuario</h1>
        </div>

        <div style={styles.body}>
          <p>
            En <strong>{CONTACTO.empresa}</strong> respetamos tu privacidad. Si
            eres usuario de nuestro sistema y deseas que eliminemos los datos
            personales asociados a tu cuenta, esta página explica cómo
            solicitarlo y qué información se elimina.
          </p>

          <h2 style={styles.h2}>Cómo solicitar la eliminación de tus datos</h2>
          <p>Puedes solicitar la eliminación de tus datos por cualquiera de estas vías:</p>
          <ol>
            <li>
              <strong>Desde la aplicación:</strong> si tienes una cuenta activa,
              pide a un administrador del sistema que elimine tu usuario desde
              el módulo <em>Administración &rarr; Usuarios</em>.
            </li>
            <li>
              <strong>Por correo electrónico:</strong> envía una solicitud a{' '}
              <a href={`mailto:${CONTACTO.email}`} style={styles.email}>
                {CONTACTO.email}
              </a>{' '}
              con el asunto <em>"Solicitud de eliminación de datos"</em>,
              indicando el nombre y el correo electrónico asociados a tu cuenta.
            </li>
          </ol>
          <p>
            Verificaremos tu identidad antes de procesar la solicitud para
            proteger la seguridad de tu cuenta.
          </p>

          <h2 style={styles.h2}>Qué datos se eliminan</h2>
          <p>Al procesar tu solicitud eliminamos o anonimizamos:</p>
          <ul>
            <li>Tu nombre de usuario y credenciales de acceso.</li>
            <li>Tu información de contacto (correo, teléfono, dirección).</li>
            <li>Tu perfil, roles y preferencias dentro del sistema.</li>
          </ul>

          <h2 style={styles.h2}>Qué datos podemos conservar</h2>
          <p>
            Por obligaciones legales, fiscales y contables, podemos conservar
            ciertos registros (por ejemplo, facturas, órdenes de compra y
            transacciones comerciales) durante el plazo que exige la ley. Estos
            registros se desvinculan de tu información personal cuando es
            posible y no se utilizan para ningún otro fin.
          </p>

          <h2 style={styles.h2}>Plazo de respuesta</h2>
          <p>
            Procesaremos tu solicitud en un plazo máximo de{' '}
            <strong>{CONTACTO.plazoDias} días</strong> a partir de su recepción
            y verificación. Te confirmaremos por correo electrónico cuando la
            eliminación se haya completado.
          </p>

          <h2 style={styles.h2}>Contacto</h2>
          <p>
            ¿Dudas sobre el tratamiento de tus datos? Escríbenos a{' '}
            <a href={`mailto:${CONTACTO.email}`} style={styles.email}>
              {CONTACTO.email}
            </a>.
          </p>
        </div>

        <div style={styles.footer}>
          {CONTACTO.empresa} &nbsp;|&nbsp; Última actualización: {hoy}
        </div>
      </div>
    </div>
  );
};

export default EliminacionDatos;
